import { ReactElement } from 'react';

import { integrationsProviders } from '~constants/integrationsProviders';

import { useIntegrationsSectionContext } from '../Context';

import { IntegrationsSectionStoresContainer } from './styles';
import IntegrationsSectionStoresCard from './Card';

const IntegrationsSectionStores = (): ReactElement => {
  const {
    dialogs: {
      add: { handleOpen: handleOpenDialogAddIntegration },
    },
  } = useIntegrationsSectionContext();

  return (
    <IntegrationsSectionStoresContainer>
      {integrationsProviders.map((integration) => (
        <IntegrationsSectionStoresCard
          key={`integration-provider-${integration.type}`}
          companyTypePermissions={integration.companyTypePermissions}
          logo={integration.logo}
          commingSoon={integration.commingSoon}
          onClick={() => handleOpenDialogAddIntegration(integration.type)}
        />
      ))}
    </IntegrationsSectionStoresContainer>
  );
};

export default IntegrationsSectionStores;
